// extracted by mini-css-extract-plugin
module.exports = {"logsContainer":"styles_logsContainer__2LQnl"};